import { logWrapper } from '../../utils';

export default {
  linkFileModalController: [
    'runtimeConstant',
    '$scope',
    'revisionListService',
    function (runtimeConstant, $scope, revisionListService) {
      'use strict';

      function parent_cancelButton() {
        $scope.modalQuestion.close();
      }

      function questionModal() {
        return new Promise((resolve) => {
          $scope.linkService.originalList.forEach((f) => {
            var doc = revisionListService.documents.filter(
              (d) => d.id === f.id
            );
            $scope.updateDocs(doc, true);
          });

          $scope.clearLinkFilesVars();
          $scope.modalQuestion.close();
          resolve();
        });
      }

      function run() {
        try {
          $scope.$parent.cancelButton = logWrapper(
            parent_cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.questionModal = logWrapper(
            questionModal,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
